export default __webpack_public_path__ + "static/media/tablet-background-img-min-dark.ab0ba46b.png";